import { withTypeSafeApiResult } from '@/packages/typesafe-result';

import {
  type IGetMetaRequest,
  type IGetMetaResponse,
  fetchGetMeta as fetchGetMetaApi,
} from '@/repositories/generated/shared/search-offers-index/v2/get-meta';

export const fetchGetMetaSafe = withTypeSafeApiResult<IGetMetaRequest, IGetMetaResponse>(fetchGetMetaApi);
